var map = {
	"./Afganistan_1978_001.jpg": 767646,
	"./Afganistan_1978_002.jpg": 547241,
	"./Afganistan_1978_003.jpg": 391980,
	"./Afganistan_1978_004.jpg": 98295,
	"./Afganistan_1978_005.jpg": 110778,
	"./Afganistan_1978_006.jpg": 814981,
	"./Afganistan_1978_007.jpg": 171016,
	"./Afganistan_1978_008.jpg": 610131,
	"./Afganistan_1978_009.jpg": 938518,
	"./Afganistan_1978_010.jpg": 276252,
	"./Afganistan_1978_011.jpg": 873625,
	"./Afganistan_1978_012.jpg": 217486,
	"./Afganistan_1978_013.jpg": 843947,
	"./Afganistan_1978_014.jpg": 21112,
	"./Afganistan_1978_015.jpg": 328373,
	"./Afganistan_1978_016.jpg": 661034,
	"./Afganistan_1978_017.jpg": 800039,
	"./Afganistan_1978_018.jpg": 402036,
	"./Afganistan_1978_019.jpg": 980561,
	"./Afganistan_1978_020.jpg": 984269,
	"./Afganistan_1978_021.jpg": 239376,
	"./Afganistan_1978_022.jpg": 806751,
	"./Afganistan_1978_023.jpg": 615042,
	"./Afganistan_1978_024.jpg": 700273,
	"./Afganistan_1978_025.jpg": 212116,
	"./Afganistan_1978_026.jpg": 158179,
	"./Afganistan_1978_027.jpg": 268070,
	"./New_Delhi_June_1978_001.jpg": 858684,
	"./New_Delhi_June_1978_002.jpg": 243339,
	"./New_Delhi_June_1978_003.jpg": 565294,
	"./New_Delhi_June_1978_004.jpg": 600917,
	"./New_Delhi_June_1978_005.jpg": 180248,
	"./New_Delhi_June_1978_006.jpg": 976583,
	"./New_Delhi_June_1978_007.jpg": 8842,
	"./New_Delhi_June_1978_008.jpg": 379953,
	"./New_Delhi_June_1978_009.jpg": 408148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619831;